import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { ContactFormPopup } from './ContactFormPopup';
export function Navigation() {
  const {
    language,
    t,
    getPath
  } = useLanguage();
  const [isLangMenuOpen, setIsLangMenuOpen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const handleLanguageChange = (lang: 'en' | 'ru' | 'ua') => {
    const currentPath = window.location.pathname;
    let newPath = currentPath;
    if (currentPath.startsWith('/ru')) {
      newPath = currentPath.substring(3) || '/';
    } else if (currentPath.startsWith('/ua') || currentPath.startsWith('/uk')) {
      newPath = currentPath.substring(3) || '/';
    }
    if (lang === 'ru') {
      newPath = `/ru${newPath === '/' ? '' : newPath}`;
    } else if (lang === 'ua') {
      newPath = `/ua${newPath === '/' ? '' : newPath}`;
    }
    window.location.href = newPath;
  };
  const navLinks = [{
    label: t('nav.services'),
    href: '#services'
  }, {
    label: 'FAQ',
    href: '#faq'
  }, {
    label: t('testimonials.title'),
    href: '#testimonials'
  }];
  return <>
      <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl nav-blur" style={{
      borderBottom: '1px solid var(--border)'
    }} data-id="element-302">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-5 flex items-center justify-between" data-id="element-303">
          {/* Logo */}
          <a href={getPath('')} className="flex items-center gap-1" data-id="element-304">
            <span className="text-xl sm:text-2xl font-semibold tracking-tight" style={{
            color: 'var(--text-primary)'
          }} data-id="element-305">
              M
            </span>
            <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full" style={{
            backgroundColor: 'var(--accent)'
          }} data-id="element-306" />
          </a>

          {/* Desktop nav links — hidden on mobile */}
          <div className="hidden md:flex items-center gap-8" data-id="element-307">
            {navLinks.map(link => <a key={link.href} href={link.href} className="text-sm font-medium transition-colors hover:opacity-80" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-308">
                {link.label}
              </a>)}
          </div>

          <div className="flex items-center gap-2 sm:gap-4" data-id="element-309">
            {/* Language Dropdown */}
            <div className="relative" data-id="element-310">
              <button onClick={() => setIsLangMenuOpen(!isLangMenuOpen)} className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg border text-sm font-medium transition-all" style={{
              borderColor: 'var(--border)',
              backgroundColor: 'var(--bg-secondary)',
              color: 'var(--text-primary)'
            }} data-id="element-311">
                <span className="uppercase" data-id="element-312">{language}</span>
                <ChevronDownIcon className="w-3 h-3 sm:w-4 sm:h-4" style={{
                color: 'var(--text-muted)'
              }} data-id="element-313" />
              </button>

              <AnimatePresence data-id="element-314">
                {isLangMenuOpen && <>
                    <div className="fixed inset-0 z-40" onClick={() => setIsLangMenuOpen(false)} data-id="element-315" />
                    <motion.div initial={{
                  opacity: 0,
                  y: -10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: -10
                }} transition={{
                  duration: 0.2
                }} className="absolute top-full mt-2 right-0 rounded-lg border overflow-hidden shadow-lg min-w-[80px] z-50" style={{
                  backgroundColor: 'var(--bg-secondary)',
                  borderColor: 'var(--border)'
                }} data-id="element-316">
                      {['en', 'ru', 'ua'].map(lang => <button key={lang} onClick={() => handleLanguageChange(lang as 'en' | 'ru' | 'ua')} className="w-full px-4 py-2 text-left text-sm font-medium transition-colors" style={{
                    backgroundColor: language === lang ? 'var(--accent)' : 'transparent',
                    color: language === lang ? '#FFFFFF' : 'var(--text-primary)'
                  }} data-id="element-317">
                          {lang.toUpperCase()}
                        </button>)}
                    </motion.div>
                  </>}
              </AnimatePresence>
            </div>

            {/* CTA Button */}
            <button onClick={() => setIsPopupOpen(true)} className="px-3 sm:px-6 py-2 sm:py-3 rounded-lg text-xs sm:text-sm font-medium transition-all hover:scale-105 whitespace-nowrap" style={{
            backgroundColor: 'var(--accent)',
            color: '#FFFFFF'
          }} data-id="element-318">
              {t('nav.getStarted')}
            </button>
          </div>
        </div>
      </nav>

      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-319" />
    </>;
}